document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('change', onCardSwatchChange);
});

function onCardSwatchChange(event) {
  if (!event.target.classList.contains('card-swatch')) return;
  const productHandle = event.target.dataset.productHandle;
  if (!productHandle) return;
  const card = event.target.closest('.card-wrapper.product-card-wrapper');
  if (!card) return;
  const variantId = event.target.dataset.variantId;
  if (!variantId) return;
  const sectionId = 'card-product-section';
  const url = `${((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')}products/${productHandle}?variant=${variantId}&section_id=${sectionId}`;

  fetch(url)
    .then((res) => res.text())
    .then((responseText) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseText, 'text/html');
      const newCardEl = doc.querySelector(`#card-product-${card.dataset.productId}`);
      if (!newCardEl) return;
      card.replaceWith(newCardEl);
      revealCheckedSwatch(newCardEl);
    })
    .catch(() => {});
}

// The swatch track scrolls horizontally, and the replacement card comes back
// scrolled to the start. Without this the swatch that was just clicked can sit
// off-screen, so the click looks like it did nothing.
function revealCheckedSwatch(card) {
  const track = card.querySelector('.product-card-swatch__track');
  if (!track) return;
  const checked = track.querySelector('.swatch-input__input:checked');
  const target = checked && checked.nextElementSibling;
  if (!target) return;
  // Centre it in the track without scrolling the page itself.
  const offset = target.offsetLeft - (track.clientWidth - target.offsetWidth) / 2;
  track.scrollLeft = Math.max(0, offset);
}

function buildCardFetchUrl(productHandle, optionValues, sectionId) {
  const base = `${((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')}products/${productHandle}`;
  const params = new URLSearchParams();
  params.set('section_id', sectionId);
  if (optionValues.length > 0) {
    params.set('option_values', optionValues.join(','));
  }
  return `${base}?${params.toString()}`;
}

function getCardOptionValues(card) {
  const fieldsets = card.querySelectorAll('.product-form__input--swatch');
  let chosen = [];
  fieldsets.forEach((fieldset) => {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) {
      const pos = parseInt(checked.dataset.optionPosition, 10);
      const val = checked.dataset.swatchValue;
      chosen[pos - 1] = val;
    }
  });
  return chosen.filter((val) => val !== undefined);
}